<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div>
  <form [formGroup]="frmFilterMovementHistory">
    <div class="grid">
      <div class="col md:col-4">
        <p-calendar
          [firstDayOfWeek]="1"
          dateFormat="dd/mm/yy"
          formControlName="rangeDates"
          selectionMode="range"
          [readonlyInput]="true"
          styleClass="w-full"
          placeholder="Filtra per data..."
          [showClear]="true"
          appendTo="body"></p-calendar>
      </div>
      <div class="col md:col-4">
        <p-dropdown
          placeholder="Filtra per tipo di movimento..."
          optionLabel="name"
          optionValue="value"
          styleClass="w-full"
          [showClear]="true"
          [emptyMessage]="'Nessun risultato trovato'"
          [options]="movement_types"
          [filter]="true"
          appendTo="body"
          formControlName="movement"></p-dropdown>
      </div>
      <div class="col md:col-4">
        <p-autoComplete
          [suggestions]="suggestedUsers"
          (completeMethod)="filterUsers($event)"
          field="fullName"
          id="id"
          class="flex-grow-1"
          dataKey="id"
          [emptyMessage]="'Nessun risultato trovato'"
          formControlName="related_user"
          [forceSelection]="true"
          [showClear]="true"
          styleClass="w-full"
          placeholder="Filtra per utente..."
          [showClear]="true"></p-autoComplete>
      </div>
      <div class="col-12">
        <p-button
          styleClass="butt w-full"
          icon="pi pi-filter-slash"
          (click)="clearAssetMovementHisotry(dt2, $event)"
          pTooltip="Elimina filtri"
          tooltipPosition="top"></p-button>
      </div>
    </div>
  </form>
  <p-table
    [paginator]="true"
    [value]="asset_movement_history"
    #dt2
    [rows]="25"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="true"
    [loading]="loading"
    (onLazyLoad)="loadAssetMovementHistory($event)"
    [totalRecords]="totalRecordsMovementsHistory"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th>Data</th>
        <th>Movimento</th>
        <th>Utente</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-a>
      <tr>
        <td>{{ a.created_on | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <span *ngIf="a.operation_type === 'C'">Carico</span>
          <span *ngIf="a.operation_type === 'S'">Scarico</span>
          <span *ngIf="a.operation_type === 'R'">Rientro</span>
          <span *ngIf="a.operation_type === 'T'">Trasferimento</span>
          <span *ngIf="a.operation_type === 'A'">Rettifica</span>
        </td>
        <td>{{ a.related_user?.name || '-' }} {{ a.related_user?.last_name || '-' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="3"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
